/**
 * errorMessage(err, fallback) — DIE Entscheidung, welcher Text dem Nutzer gezeigt wird.
 * Komponenten lesen nie `err.message` direkt: Nur ein ApiClientError mit Status 4xx trägt einen
 * für den Nutzer formulierten Server-Text; 5xx ist generisch, Netzwerk bekommt einen festen
 * Hinweis, alles andere den Fallback des Aufrufers. Übersetzung setzt später genau hier an
 * (`t(err.code) ?? err.message`).
 * Spec: docs/superpowers/specs/2026-08-25-error-handling-system.md §4.2
 */
import { ApiClientError } from './ApiClientError';

export const NETWORK_ERROR_MESSAGE = 'Keine Verbindung zum Server. Bitte prüfe deine Internetverbindung.';

export function errorMessage(err, fallback) {
  if (!(err instanceof ApiClientError)) return fallback;
  if (err.status === 0) return NETWORK_ERROR_MESSAGE;
  if (err.status >= 500) return fallback;
  return err.message || fallback;
}
